import React from "react";
import { 
  Badge, 
  Box, 
  Flex, 
  Text, 
  SimpleGrid,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,  
} from "@chakra-ui/core";

/** The core content of the dashboard rendering the actuall datas tables */

const DashboardDataMockup = () => {
  return (
    <>
      <Box width="100%" background="#eeedee" p={0}>
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="800px" w="100%" h="100%">
            <Box background="white" pt="8px" m="auto" mx="10px" px="2px">
              <Stack mb="16px" isInline w="100%" justifyContent="center">
                <InputGroup width="100%" maxW="600px">
                  <InputLeftElement
                    children={<Icon name="search" color="primary.500" />}
                  />
                  <Input
                    isDisabled
                    borderColor="primary.400"
                    borderWidth="2px"
                    focusBorderColor="success.500"
                    maxW="600px"
                    type="text"
                    placeholder={"Search orders"}
                  />
                </InputGroup>
              </Stack>
              <SimpleGrid
                columns={4}
                spacing={0}
                color="primary.400"
                fontSize={["xs", "sm", "sm", "sm"]}
              >
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Text fontWeight="bold">Victor Hugo</Text>
                  <Text fontSize="xs">10.06.2020</Text>
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  Pizza with pinneapple
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  30,78 €
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Badge fontSize="0.8em" variantColor="success">
                    Paid
                  </Badge>
                </Box>

                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Text fontWeight="bold">Peter Pan</Text>
                  <Text fontSize="xs">10.06.2020</Text>
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  Vegetables box
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  120,00 € 
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Badge fontSize="0.8em" variantColor="warning">
                    Cancelled
                  </Badge>
                </Box>

                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Text fontWeight="bold">Don Juan</Text>
                  <Text fontSize="xs">10.06.2020</Text>
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  Exotic tea selection
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  19,99 €
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Badge fontSize="0.8em" variantColor="danger">
                    Refunded
                  </Badge>
                </Box>

                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Text fontWeight="bold">Albert Einstein</Text>
                  <Text fontSize="xs">10.06.2020</Text>
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  Birthday flower bouquet
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  43,30 €
                </Box>
                <Box borderBottomWidth="1px" p="4px" height="auto">
                  <Badge fontSize="0.8em" variantColor="primary">
                    Pending
                  </Badge>
                </Box>
              </SimpleGrid>
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default DashboardDataMockup;
